/**
 * RenderIcon — renders an SVG icon by name from the Icons dictionary
 */
import { Icons } from '@/data/icons';

interface RenderIconProps {
  name: string;
  size?: number;
}

export function RenderIcon({ name, size = 20 }: RenderIconProps) {
  const svg = (Icons as any)[name];
  if (!svg) return null;

  return (
    <span
      className="icon"
      style={{ display: 'inline-flex', width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
